import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { UserService } from '@referral/services/UserService';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => UserService.getList(params)
    }
  },
  true
);
